import React, {useState} from "react"
import {Accordion, Button, Card, Modal} from "react-bootstrap";
import {faqList} from "../_utils";
import Parser from "html-react-parser";

const Faq = (props) => {
    let {children} = props;
    let [visible, setVisible] = useState(false);
    let [selectBox, setSelectBox] = useState(false);
    const handleClose = () => {
        setVisible(false)
    }
    const _chooseBox = (item) => {
        if (selectBox == item) {
            setSelectBox(null)
        } else {
            setSelectBox(item)
        }
    }
    const renderIcon = (item) => {
        return (
            <React.Fragment>{selectBox == item ? <i className={'fa fa-minus'}></i> :
                <i className={'fa fa-plus'}></i>}</React.Fragment>
        )
    }

    return (
        <>
            <a onClick={() => {
                setVisible(true)
            }}>
                {children}
            </a>

            {visible ?
                <Modal show={visible} onHide={handleClose}
                       dialogClassName={'faqModal'}>
                    <Modal.Header closeButton>
                        <Modal.Title>FAQ's</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Accordion defaultActiveKey="0">
                            {faqList.map((item, index) => {
                                let keyValue = index.toString()
                                return (
                                    <Card key={item.question}>
                                        <Card.Header>
                                            <Accordion.Toggle as={Button} variant="link" eventKey={keyValue}
                                                              onClick={() => _chooseBox(index)}>
                                                <div className={'question_row'}>
                                                    {/*<div><strong>Q{index + 1}.</strong> &nbsp;{item.question}</div>*/}
                                                    <div>{item.question}</div>
                                                    {renderIcon(index)}
                                                </div>
                                            </Accordion.Toggle>
                                        </Card.Header>
                                        <Accordion.Collapse eventKey={keyValue}>
                                            <Card.Body>
                                                {Parser(item.answer)}
                                            </Card.Body>
                                        </Accordion.Collapse>
                                    </Card>
                                )
                            })}

                        </Accordion>

                    </Modal.Body>
                </Modal> : null}
        </>
    )
}
export default Faq
